import { runInAction, makeAutoObservable } from "mobx";

import { ExecutionStatus } from "../../../services/general/requestsResponses";
import {
    cancelInvoiceOrder,
    getOrganisationBranch,
    getServiceLegalDetails, getServiceOrders,
    updateCompanyCard, updateLegalData
} from "../../../services/organizationBranches/index"
import {CardServiceOrder, InvoiceServiceOrder, OrganizationBranch} from "../../../services/organizationBranches/models";
import {
    OrganizationBranchesUpdateCompanyCardRequest,
    OrganizationBranchesUpdateLegalDataRequest, ServiceOrdersCancelInvoiceOrderRequest
} from "../../../services/organizationBranches/requestsResponses";
import rootStore from "../../../stores";
import moment from 'moment';


class DocumentsStore {

    isError: boolean = false;
    isOrganizationBranchLoaded: boolean = false;
    organizationBranch: OrganizationBranch;
    serviceLegalDetails: any | null = null;
    isServiceLegalDetailsLoaded: boolean = false;
    serviceOrders: (CardServiceOrder | InvoiceServiceOrder)[] = []
    isServiceOrdersLoaded: boolean = false;

    async getServiceLegalDetails() {
        const response = await getServiceLegalDetails({})

        runInAction(() => {
            this.serviceLegalDetails = response.paymentProviderDetails;
            this.isServiceLegalDetailsLoaded = true;
        })
    }

    async getOrganisationBranch() {
        const authStore = rootStore.authStore;
        const response = await getOrganisationBranch({organizationBranchId: authStore.currentUser.organizationData.organizationBranchId});
        runInAction(() => {
            this.organizationBranch = {
                ...response.organizationBranch,
                activeTariffDetails: {
                    ...response.organizationBranch.activeTariffDetails,
                    nextPaymentDate: moment(response.organizationBranch.activeTariffDetails.nextPaymentDate).toDate(),
                    menusActiveTillDate: moment(response.organizationBranch.activeTariffDetails.menusActiveTillDate).toDate()
                }
            };
            this.isOrganizationBranchLoaded = true;
        })
    }

    async updateCompanyCard (dataUpdateApplication: OrganizationBranchesUpdateCompanyCardRequest) {
        const response = await updateCompanyCard(dataUpdateApplication);
        if(!response){
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }
        await this.getOrganisationBranch();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;

    }
    
    async updateLegalData(data: OrganizationBranchesUpdateLegalDataRequest) {
        const response = await updateLegalData(data);

        if (!response) {
            runInAction(()=> {
                this.isError = true;
            });
            return;
        }

        await this.getOrganisationBranch();
        this.isError = false;
        return response.executionStatus === ExecutionStatus.Finished;
    }

    async getServiceOrders() {
        this.isServiceOrdersLoaded = false
        const response = await getServiceOrders()

        runInAction(() => {
            this.serviceOrders = response.serviceOrders
            this.isServiceOrdersLoaded = true
        })
    }

    async cancelInvoiceOrder(data: ServiceOrdersCancelInvoiceOrderRequest) {
        const response = await cancelInvoiceOrder(data)

        if (!response) {
            runInAction(() => {
                this.isError = true
            })
            return false
        }

        this.isServiceOrdersLoaded = false;
        await this.getServiceOrders()
        this.isError = false;
        return true
    }


    constructor() {
        makeAutoObservable(this)
    }



}


export default DocumentsStore
